import { TDocumentsDraft } from 'src/modules/assistant/actions/types';

/**
 * A draft that asks for documentation needs at least one attachment.
 */
export const hasRequiredDocuments = (draft: TDocumentsDraft): boolean =>
    !draft.documentationRequested || Boolean(draft.attachments?.length);
